const state = {
  /* #region  stock */
  inputRecord: {
    otp: {
      countdown: 0,
      interval: null,
      message: '',
      phone: null,
      expired: null,
    },
    selectedDialCode: {
      code: 'ID',
      dial_code: '+62',
      flag: '🇮🇩',
      name: 'Indonesia',
    },
  },
  isRegisterSuccess: false,
  liveTrade: [],
  liveTradeDetail: {},
  buyStock: {},
  sellStock: {},
  myStock: [],
  lastPriceStock: {},
  stockDetails: {},
  analysisStock: [],
  listStock: [],
  chartStock: {},

  /* #endregion */

  /* #region  member */
  listProgram: [],
  /* #endregion */

  /* #region  notification */
  listNotification: [],
  listNotificationCategory: [],
  /* #endregion */

  /* #region  analysis */
  listAnalysis: [],
  analysis: {},
  /* #endregion */

  /* #region  content */
  listContent: [],
  listContentChild: [],
  content: {},
  listEvent: [],
  listPromotionBanner: [],
  listTicker: [],
  listBannerEducation: [],
  educationHome: [],
  analysisHome: [],
  faqHome: [],
  /* #endregion */

  /* #region  faq */
  listFaq: [],
  faq: [],
  faqFrequent: [],
  faqLast: [],
  listFaqRelated: [],
  /* #endregion */

  /* #region  QnA */
  listChat: [],
  maxQnaActive: false,
  hasOngoingQna: {
    status: false,
    message: '',
  },
  listBelanja: [],
  listLangganan: [],
  tiket: [],
  listTiket: [],
  tiketDetail: [],
  listTiketDetail: [],
  statusQa: {},
  portfolioQa: {},
  autoAnswer: {},
  listQuestion: [],
  /* #endregion */

  /* #region  global state */
  appVersion: '1.0.0',
  success: {
    message: '',
  },
  error: {
    status: '',
    message: '',
  },
  gsiError: {
    status: '',
    message: '',
    gsiToken: '',
  },
  categories: [],
  selectedCategory: '',
  isLoading: false,
  isSpinnerLoading: false,
  isEnableStepperGuide: false,
  pagination: {
    page_size: 20,
    current_page: 1,
    next_page: 0,
    total_page: 0,
  },
  user: {
    id: '',
    name: '',
    email: '',
    token: '',
    firebaseToken: '',
  },
  verifyUserAccount: {},
  pushNotif: {},
  newNotif: 0,
  firebaseToken: '',
  filter: {},
  search: '',
  openSearch: false,
  scrollYPos: 0,
  subscription: [],
  membership: {
    status_membership: false,
    phone_sales: 0,
    message: '',
  },
  enableFeature: {
    feature: '',
    status: false,
    message: '',
    product: [],
    type: 'none',
    submited: false,
  },
  membershipData: {},
  promotion: {},
  promotionPopup: [],
  currentPromotionPopup: 0,
  appearedPromotions: [],
  /* #endregion */

  listForYou: [],
  landingpage: {},
  forgotSuccessDialog: false,
  resendOTPRemaining: 0,
  isOpenTermCondition: true,
  isOpenDisclaimer: false,
  isClosePopupBanner: false,
  isPremiumContent: false,
  isVipFeatures: false,
  isToManyLogin: false,
  isOpenModalSuccessChangePassword: false,
  isOpenModalContactSupport: false,
  isOpenModalVideoTutorial: false,
  isOpenModalShare: false,
  isOpenModalRewardRiskRatioCalculation: false,
  chartConfig: {},
  previewImage: {
    isOpen: false,
    src: null,
  },
  pageHistory: [],
  dialCode: [],
  userAgent: '',
  fingerprint: '',
}

export default state
